module.exports = __webpack_public_path__ + "static/media/25014.0e90ba7d.jpg";